import { useState, useEffect } from 'react';

const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timeoutRef = setTimeout(() => setDebouncedValue(value), delay);

    return () => clearTimeout(timeoutRef);
  }, [value]);

  return debouncedValue;
};

export default useDebounce;
